import { render, staticRenderFns } from "./NewApplication.vue?vue&type=template&id=38ed9881"
import script from "./NewApplication.vue?vue&type=script&lang=ts"
export * from "./NewApplication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports